import { render, staticRenderFns } from "./formLink.vue?vue&type=template&id=5cfa5d64&"
import script from "./formLink.vue?vue&type=script&lang=js&"
export * from "./formLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports